import { render, staticRenderFns } from "./NormalHeader.vue?vue&type=template&id=dc7af3f4&scoped=true"
import script from "./NormalHeader.vue?vue&type=script&lang=js"
export * from "./NormalHeader.vue?vue&type=script&lang=js"
import style0 from "./NormalHeader.vue?vue&type=style&index=0&id=dc7af3f4&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7af3f4",
  null
  
)

export default component.exports